import { Subscription, SubscriptionAddon } from '@core/models/subscription.model';

/** GP Due Diligence add-on code from profile / current subscription `activeAddons` (backend seed). */
export const GP_ADDON_DD_CODE = 'gp_addon_due_diligence';

/** Short code used in older fixtures; still accepted when present in `activeAddons`. */
const GP_ADDON_DD_LEGACY_CODES: readonly string[] = ['gp_addon_dd'];

function isActiveGpDueDiligenceAddon(addon: SubscriptionAddon): boolean {
  if (addon.isActive === false) {
    return false;
  }
  const code = String(addon.code ?? '').trim();
  if (code === GP_ADDON_DD_CODE || GP_ADDON_DD_LEGACY_CODES.includes(code)) {
    return true;
  }
  return String(addon.addonType ?? '').trim().toLowerCase() === 'due_diligence';
}

export function hasActiveGpAddonDd(subscription: Subscription | null | undefined): boolean {
  const addons = subscription?.activeAddons ?? [];
  return addons.some(isActiveGpDueDiligenceAddon);
}
